'use strict';

const Mn = require('backbone.marionette');
const i18n = require('i18next');
const Moment = require('moment');
const TypeaheadView = require('common/ui/view/typeahead');
const ReviewAction = require('notify/domain/action/review');
const ReviewRepository = require('notify/domain/repository/review');
const ReviewListView = require('notify/ui/view/review-list');
const Template = require('balus/ui/template/sidepanel/review.hbs');
const DropdownItemTemplate = require('balus/ui/template/body/user/content/dropdown-item.hbs');
const FilterTemplate = require('balus/ui/template/body/user/content/filter.hbs');

const TypeaheadViewPermitEmpty = TypeaheadView.extend({
    search: function() {
        this._query = this.query();
        if(!_.isString(this._query)) {
            this.hide();
            return;
        }

        let items = this.find(this._query);
        if(_.isFunction(items)) {
            items(_.bind(function(items){
                this.updateItems(items);
            }, this));
        } else {
            this.updateItems(items);
        }
    },

    getNotification: function() {
        const makeItemList = function(reviews) {
            let itemList = [];

            _.each(reviews, review => {
                if(!itemList.some(status => status.name === review.get('project').name)) {
                    review.get('project').kind = "project";
                    review.get('project').kindchar = i18n.t('balus_template_body_user:content.dropdown-menu.kind.project');
                    itemList.push(review.get('project'));
                }
            });

            _.each(reviews, review => {
                if(review.get('message').action &&
                    !itemList.some(status => status.name === review.get('message').action.name)) {
                    review.get('message').action.kind = "action";
                    review.get('message').action.kindchar = i18n.t('balus_template_body_user:content.dropdown-menu.kind.action');
                    itemList.push(review.get('message').action);
                }
            });

            return itemList;
        };

        const type = $('.notification-type').find('input:checked').val();

        return new Promise((resolve, reject) => {
            let rawReviews = ReviewRepository.getReviews();
            Promise.all([ReviewAction.fetchReviewsOnce({all: true}),
                ReviewAction.fetchReviewsOnce({all: false})]).then(() => {
                const reviews = rawReviews.clone();
                if(type === 'unread') {
                    reviews.reset(reviews.filter(r => !r.get('read')));
                } else {
                    reviews.reset(reviews.filter(r => r.get('read')));
                }
                const itemList = makeItemList(reviews.models);
                resolve(itemList);
            });
        });
    }
});

const FilterMessageView = Mn.View.extend({
    template: FilterTemplate,
    events: {
        'click .filter-reset': 'filterReset'
    },
    templateContext: function() {
        return { message: this.model.message }
    },
    filterReset: function() {
        this.trigger('filter:reset');
    }
});

module.exports = Mn.View.extend({
    template: Template,
    regions: {
        'unreadList': '.unread-review-list-wrapper',
        'readList': '.read-review-list-wrapper',
        'filterActivate': '.filter-activate'
    },
    ui: {
        'closeButton': '.close-sidepanel',
        'unreadButton': '.unread-button',
        'readButton': '.read-button',
        'searchQuery': '.search-query'
    },
    triggers: {
        'click @ui.closeButton': 'close:sidepanel'
    },
    events: {
        'click @ui.unreadButton': 'showUnread',
        'click @ui.readButton': 'showRead'
    },
    childViewEvents: {
        'filter:reset': 'filterReset'
    },

    initialize: function() {
        this._latestReadTime = Moment();
        this._unreadCollection = new Backbone.Collection();
        this._readCollection = new Backbone.Collection();

        this._reviews = ReviewRepository.getReviews();
        this.listenTo(this._reviews, 'reset add change:read remove',
            this.updateCollections);
        this.updateCollections();
    },

    onRender: function() {
        this.renderUnread();
        this.renderRead();
        this._latestReadTime = Moment();

        if(!this._typeaheadView) {
            this.dropDownInit();
        }
        this.listenTo(this._typeaheadView, 'selected:list', this.updateCollectionsByFilter);
    },

    renderUnread: function() {
        ReviewAction.fetchReviewsOnce({all: false});

        this.showChildView('unreadList', new ReviewListView({
            collection: this._unreadCollection,
            read: false,
            latestReadTime: this._latestReadTime
        }));
    },

    renderRead: function() {
        ReviewAction.fetchReviewsOnce({all: true});

        this.showChildView('readList', new ReviewListView({
            collection: this._readCollection,
            read: true,
            latestReadTime: this._latestReadTime
        }));
    },

    showUnread: function() {
        this.getRegion('readList').$el.hide();
        this.getRegion('unreadList').$el.show();
        this.ui.readButton.removeClass('is-active');
        this.ui.unreadButton.addClass('is-active');
    },

    showRead: function() {
        this.getRegion('unreadList').$el.hide();
        this.getRegion('readList').$el.show();
        this.ui.unreadButton.removeClass('is-active');
        this.ui.readButton.addClass('is-active');
    },

    updateCollections: function() {
        this._unreadCollection.reset(this._reviews.filter(r => !r.isRead()));
        this._readCollection.reset(this._reviews.filter(r => r.isRead()));
    },

    dropDownInit: function() {
        this._typeaheadView = new TypeaheadViewPermitEmpty({
            el: this.ui.searchQuery,

            find: function(query) {
                let deferred = $.Deferred();
                this.getNotification().then((list) => {
                    let itemList = list;
                    if(query) {
                        itemList = list.filter(item => { return item.name.indexOf(query) > -1 });
                    }
                    deferred.resolve(itemList);
                });

                return deferred.done;
            },
            // DropDown が選択された時に呼ばれる
            update: this.add,
            // itemView は DropdownItemView を使って作成
            itemView: TypeaheadViewPermitEmpty.DropdownItemView.extend({
                template: DropdownItemTemplate
            })
        });
    },

    add: function(model) {
        this.trigger('selected:list', model);
        return '';
    },

    updateCollectionsByFilter: function(model) {
        const actionFilter = (model, key) => {
            if(model.get('message').action) {
                return model.get('message').action.key === key;
            }};
        if(model) {
            if(model.get('kind') === 'action') {
                const actionKey = model.get('key');
                this.updateCollections();
                this._readCollection.reset(this._readCollection.filter(r => actionFilter(r, actionKey)));
                this._unreadCollection.reset(this._unreadCollection.filter(r => actionFilter(r, actionKey)));
                this.showChildView('filterActivate', new FilterMessageView({
                    model: { message: i18n.t('balus_template_body_user:content.dropdown-menu.message.action',
                        { name: model.get('name'), interpolation: { escapeValue: false } }) }
                }));

            } else if(model.get('kind') === 'project') {
                const projectID = model.get('id');
                this.updateCollections();
                this._readCollection.reset(this._readCollection.filter(r => r.get('project').id === projectID));
                this._unreadCollection.reset(this._unreadCollection.filter(r => r.get('project').id === projectID));
                this.showChildView('filterActivate', new FilterMessageView({
                    model: { message: i18n.t('balus_template_body_user:content.dropdown-menu.message.project',
                        { name: model.get('name'), interpolation: { escapeValue: false } }) }
                }));
            }
        }
    },

    filterReset: function() {
        this.getRegion('filterActivate').empty();
        this.updateCollections();
    }
});



// WEBPACK FOOTER //
// ./balus/ui/view/sidepanel/review.js